import { useEffect, useState } from 'react'
import { callAxios } from '../hooks/useAxios'
import { Widget, WidgetData } from '../classes/widgets/Widget'
import { useDevices } from '../hooks/useDevices'

export interface WidgetViewProps {
  widget: Widget
  configure?: boolean
  onRefresh?: () => void
}

/**
 * Viewer of dashboard presentation of appliance.
 */
export function WidgetView(props: WidgetViewProps): React.ReactElement {
  const { widget, configure } = props

  const [edit, setEdit] = useState(false)
  const [count, setCount] = useState(0)
  const { control } = useDevices()

  const onRefresh = () => {
    setCount((count + 1) % 100)
  }

  widget.connectControls(control)

  const onSave = async (data: Partial<WidgetData>) => {
    await callAxios({
      method: 'PATCH',
      url: `/widgets/${data.id}`,
    }, data)
    props.onRefresh && props.onRefresh()
  }

  if (configure) {
    return widget.configurationView({
      onClickEdit: () => setEdit(!edit),
      onChangeName: (name: string) => {
        widget.name = name
        onRefresh()
      },
      onSave: async () => {
        await onSave({ id: widget.id, name: widget.name })
        setEdit(false)
        onRefresh()
      },
      onClickVisibility: async () => {
        await onSave({ id: widget.id, visible: !widget.visible })
        onRefresh()
      },
      edit
    })
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    widget.fetchData().then(() => widget.beforeRefresh().then(() => onRefresh()))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return widget.dashboardView({
    upgrading: widget.isUpgrading(),
    refresh: () => onRefresh()
  })
}
